import { useContext, useMemo } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

// Selections in Options-page order; auto-selected options already live in selectedOptions.
export default function useSelectionSummary(): string[] {
  const { customizeOptions, selectedOptions } = useContext(ParentModelContext);

  return useMemo(() => {
    const {
      driveTypes,
      engines,
      exteriorColors,
      interiorColors,
      packageOptions,
      trim
    } = customizeOptions.data;

    const summary: string[] = [];

    if (trim) {
      summary.push(trim);
    }

    const exteriorColor = exteriorColors.find(
      color => color.code === selectedOptions?.exteriorColorCode
    );
    if (exteriorColor) {
      summary.push(exteriorColor.name);
    }

    const interiorColor = interiorColors.find(
      color => color.code === selectedOptions?.interiorColorCode
    );
    if (interiorColor) {
      summary.push(interiorColor.name);
    }

    const driveType = driveTypes.find(
      type => type.name === selectedOptions?.driveType
    );
    if (driveType) {
      summary.push(driveType.name);
    }

    const engine = engines.find(
      option => option.code === selectedOptions?.engineCode
    );
    if (engine) {
      summary.push(engine.name);
    }

    packageOptions.forEach(option => {
      if (selectedOptions?.packageOptionCodes?.includes(option.code)) {
        summary.push(option.name);
      }
    });

    return summary;
  }, [customizeOptions.data, selectedOptions]);
}
